import React, { useEffect, useState } from "react";
import withStyles from "react-jss";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";

const styles = theme => {
    return {
        CardLink: {
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
            fontFamily: theme.fonts.medium,
            backgroundColor: theme.palette.colors.white,
            border: `1px solid ${theme.palette.colors.disabled}`,
            borderRadius: "10px",
            padding: "15px",
            height: "100%",
        },
        CardLinkTopBlock: {
            display: "flex",
            flexDirection: "column",
            height: "55%",
        },
        CardLinkAdress: {
            fontFamily: theme.fonts.bold,
            color: theme.palette.colors.darkSlateBlue2,
            fontSize: "18px",
            lineHeight: "22px",
            marginTop: "auto",
            marginBottom: "auto",
            cursor: "pointer",
        },
        CardLinkLogoRow: {
            display: "flex",
            justifyContent: "space-around",
            gap: "10px",
            height: "30px",
            marginTop: "auto",
            marginBottom: 0,
            "& img": {
                width: "calc(20% - 10px)",
                objectFit: "contain",
            },
        },
        CardLinkFeatures: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
        },
        CardLinkFeaturesText: {
            color: theme.palette.colors.darkSlateBlue2,
            fontSize: "14px",
            lineHeight: "14px",
            width: "55%",
        },
        CardLinkFeaturesNum: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.colors.darkSlateBlue2,
            fontSize: "18px",
            lineHeight: "14px",
            width: "45%",
        },
        CardLinkFeaturesUnit: {
            fontFamily: theme.fonts.light,
            color: theme.palette.colors.oneMoreGrey,
            fontSize: "12px",
            lineHeight: "10px",
            marginLeft: "3px",
        },
        CardLinkBadge: {
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",
            width: "fit-content",
            backgroundColor: theme.palette.colors.giftPink,
            color: theme.palette.colors.white,
            fontSize: "12px",
            lineHeight: "12px",
            border: `1px solid ${theme.palette.colors.giftPink}`,
            borderRadius: "30px",
            padding: "3px 10px",
        },
        CardLinkBadgeText: {
            fontFamily: theme.fonts.light,
            color: theme.palette.colors.oneMoreGrey,
            fontSize: "12px",
            lineHeight: "12px",
        },
        CardLinkBottomBlock: {
            display: "flex",
            flexDirection: "column",
            height: "45%",
        },
        CardLinkReview: {},
        CardLinkReviewName: {
            color: theme.palette.colors.darkSlateBlue2,
            fontSize: "14px",
            lineHeight: "16px",
            marginBottom: "4px",
        },
        CardLinkReviewDate: {
            color: theme.palette.colors.cloudyBlue,
            fontSize: "12px",
            lineHeight: "14px",
        },
        CardLinkReviewProvider: {
            color: theme.palette.colors.darkSlateBlue2,
            fontSize: "12px",
            lineHeight: "14px",
            marginBottom: "8px",
        },
        CardLinkReviewText: {
            fontFamily: theme.fonts.light,
            color: theme.palette.colors.oneMoreGrey,
            fontSize: "14px",
            lineHeight: "16px",
        },
        CardLinkFixBlock: {
            height: "32px",
        },
        CardLinkRightBlock: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            marginTop: "10px",
        },
        CardLinkLikeBlock: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "15px",
            marginTop: "auto",
            marginBottom: 0,
        },
        CardLinkLikeBlockText: {
            fontSize: "16px",
            lineHeight: "14px",
            color: theme.palette.colors.darkSlateBlue2,
        },
        CardLinkLikes: {
            display: "flex",
            gap: "15px",
        },
        CardLinkLikesNum: {
            display: "flex",
            alignItems: "flex-end",
            fontFamily: theme.fonts.bold,
            color: theme.palette.colors.liteGreen,
            fontSize: "12px",
            lineHeight: "14px",
            "& svg": {
                marginRight: "3px",
            },
        },
        CardLinkDislikesNum: {
            display: "flex",
            alignItems: "flex-end",
            fontFamily: theme.fonts.bold,
            color: theme.palette.colors.giftPink,
            fontSize: "12px",
            lineHeight: "14px",
            "& svg": {
                marginRight: "3px",
            },
        },
        likesContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "21px",
            width: "21px",
            "& svg": {
                flexShrink: 0,
            },
        },
        dislike: {
            marginBottom: "5px",
        },
        Unit: {
            fontFamily: "sans-serif",
        },
        UnitMargin: {
            marginRight: "3px",
        },
        [`@media (max-width: ${theme.media.md})`]: {
            // CardLink:{
            //     boxSizing: "inherit",
            // },
            CardLinkFeaturesText: {
                fontSize: "12px",
                whiteSpace: "nowrap",
            },
            CardLinkFeaturesNum: {
                fontSize: "16px",
            },
            CardLinkLikeBlockText: {
                fontSize: "14px",
            },
            CardLinkReviewName: {
                fontSize: "12px",
                lineHeight: "14px",
            },
            CardLinkReviewDate: {
                fontSize: "10px",
                lineHeight: "14px",
            },
            CardLinkReviewProvider: {
                fontSize: "10px",
                lineHeight: "14px",
            },
            CardLinkReviewText: {
                fontSize: "12px",
                lineHeight: "14px",
            },
        },
        [`@media (max-width: ${theme.media.xs})`]: {
            CardLinkReviewProvider: {
                marginBottom: "5px",
            },
        },
    };
};

const CardLink = props => {
    const [likeStatus, setLikeStatus] = useState(null); // 'like', 'dislike' или null
    const [likeCount, setLikeCount] = useState(0);
    const [dislikeCount, setDislikeCount] = useState(0);
    const history = useHistory();

    let {
        id,
        classes,
        place,
        adress,
        url,
        avg_speed,
        avg_price,
        price_diff,
        review,
        likes,
        dislikes,
        providers,
        searcheModel,
        commonViewModel,
        // onClickHandler,
    } = props;

    useEffect(() => {
        let cookieValue;
        if (place === "улицы") {
            cookieValue = Cookies.get("streetLikes");
        } else {
            cookieValue = Cookies.get("addressLikes");
        }
        const like = cookieValue ? JSON.parse(cookieValue) : {};
        setLikeStatus(like[id]);
        setLikeCount(likes);
        setDislikeCount(dislikes);
    }, [id, likes, dislikes]);

    const handleLikeStreet = () => {
        if (likeStatus) return; // Проверка, чтобы не изменять статус, если уже есть лайк/дизлайк

        const newLikes = {
            ...JSON.parse(Cookies.get("streetLikes") || "{}"),
            [id]: "like",
        };
        Cookies.set("streetLikes", JSON.stringify(newLikes));
        setLikeStatus("like");
        setLikeCount(prev => prev + 1);
        searcheModel.setIncrementLikeDislake({ street_id: id, like: true });
    };

    const handleLikeAddress = () => {
        if (likeStatus) return; // Проверка, чтобы не изменять статус, если уже есть лайк/дизлайк

        const newLikes = {
            ...JSON.parse(Cookies.get("addressLikes") || "{}"),
            [id]: "like",
        };
        Cookies.set("addressLikes", JSON.stringify(newLikes));
        setLikeStatus("like");
        setLikeCount(prev => prev + 1);
        searcheModel.setIncrementLikeDislake({ address_id: id, like: true });
    };

    const handleDislikeStreet = () => {
        if (likeStatus) return; // Аналогичная проверка для дизлайка

        const newLikes = {
            ...JSON.parse(Cookies.get("streetLikes") || "{}"),
            [id]: "dislike",
        };
        Cookies.set("streetLikes", JSON.stringify(newLikes));
        setLikeStatus("dislike");
        setDislikeCount(prev => prev + 1);
        searcheModel.setIncrementLikeDislake({
            street_id: id,
            dislike: true,
        });
    };

    const handleDislikeAddress = () => {
        if (likeStatus) return; // Аналогичная проверка для дизлайка

        const newLikes = {
            ...JSON.parse(Cookies.get("addressLikes") || "{}"),
            [id]: "dislike",
        };
        Cookies.set("addressLikes", JSON.stringify(newLikes));
        setLikeStatus("dislike");
        setDislikeCount(prev => prev + 1);
        searcheModel.setIncrementLikeDislake({
            address_id: id,
            dislike: true,
        });
    };

    const handleClickLink = e => {
        //Здесь костыль из-за того, что OnClick в компоненте Link не всегда вызывается
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }

        commonViewModel.changeShowModalOnRates(true);

        history.push({
            pathname: url,
        });
    };

    const reviewText =
        review?.review.length > 150
            ? review?.review.slice(0, 150).trim() + "..."
            : review?.review;
    let logoList = providers.map(elem => {
        return <img key={elem.id} src={elem.logo} alt={elem.name}></img>;
    });

    let reviewDate;

    if (review?.date) {
        let reviewDateStamp = new Date(review?.date);
        reviewDate = reviewDateStamp.toLocaleString("default", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    }

    const autorName = isNaN(+review?.author.name)
        ? review?.author.name
        : `Житель ${place}`;
    return (
        <div className={classes.CardLink}>
            <div className={classes.CardLinkTopBlock}>
                <Link
                    className={classes.CardLinkAdress}
                    onClick={handleClickLink}
                    to={url}
                >
                    {adress}
                </Link>
                <div className={classes.CardLinkLogoRow}>{logoList}</div>
                <div className={classes.CardLinkFeatures}>
                    <div className={classes.CardLinkFeaturesText}>
                        Средняя скорость
                    </div>
                    <div className={classes.CardLinkFeaturesNum}>
                        {avg_speed}
                        <div className={classes.CardLinkFeaturesUnit}>
                            Мбит/с
                        </div>
                    </div>
                </div>
                <div className={classes.CardLinkFeatures}>
                    <div className={classes.CardLinkFeaturesText}>
                        Средняя цена
                    </div>
                    <div className={classes.CardLinkFeaturesNum}>
                        {avg_price}
                        <div className={classes.CardLinkFeaturesUnit}>
                            <span className={classes.Unit}>₽</span>/мес
                        </div>
                    </div>
                </div>
                <div className={classes.CardLinkFixBlock}>
                    {price_diff && (
                        <div className={classes.CardLinkRightBlock}>
                            <div className={classes.CardLinkBadge}>
                                на {price_diff}
                                <span
                                    className={`${classes.Unit} ${classes.UnitMargin}`}
                                >
                                    ₽
                                </span>{" "}
                                дороже
                            </div>
                            <div className={classes.CardLinkBadgeText}>
                                чем в вашем доме
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className={classes.CardLinkBottomBlock}>
                {review && (
                    <div className={classes.CardLinkReview}>
                        <div className={classes.CardLinkReviewName}>
                            {autorName}
                        </div>
                        <div className={classes.CardLinkReviewDate}>
                            {reviewDate && reviewDate}
                        </div>
                        <div className={classes.CardLinkReviewProvider}>
                            {review.provider.name}
                        </div>
                        <div className={classes.CardLinkReviewText}>
                            {reviewText}
                        </div>
                    </div>
                )}
                <div className={classes.CardLinkLikeBlock}>
                    <div className={classes.CardLinkLikeBlockText}>
                        Хочу здесь жить
                    </div>
                    <div className={classes.CardLinkLikes}>
                        <div className={classes.CardLinkLikesNum}>
                            <div className={classes.likesContainer}>
                                {likeStatus !== "like" ? (
                                    <svg
                                        onClick={
                                            place == "улицы"
                                                ? handleLikeStreet
                                                : handleLikeAddress
                                        }
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M18.3402 8.82812C18.6191 8.5168 18.7891 8.10586 18.7891 7.65625C18.7891 6.68711 18.0004 5.89844 17.0312 5.89844H13.6195C13.9574 4.87305 14.1016 3.5125 14.1016 2.9293V2.34375C14.1016 1.05156 13.05 0 11.7578 0H11.1719C10.9031 0 10.6688 0.182813 10.6035 0.44375L10.2844 1.7207C9.83711 3.50898 8.41719 5.48203 6.94766 5.84063C6.69023 5.18906 6.05469 4.72656 5.3125 4.72656H1.79688C1.47344 4.72656 1.21094 4.98906 1.21094 5.3125V15.8594C1.21094 16.1828 1.47344 16.4453 1.79688 16.4453H5.3125C6.01133 16.4453 6.61602 16.0355 6.89922 15.4434L8.9125 16.1145C9.5707 16.334 10.2566 16.4453 10.9508 16.4453H15.8594C16.8285 16.4453 17.6172 15.6566 17.6172 14.6875C17.6172 14.459 17.5734 14.2402 17.4937 14.0398C18.2391 13.8363 18.7891 13.1531 18.7891 12.3438C18.7891 11.8941 18.6191 11.4832 18.3402 11.1719C18.6191 10.8605 18.7891 10.4496 18.7891 10C18.7891 9.55039 18.6191 9.13945 18.3402 8.82812ZM5.89844 14.6875C5.89844 15.0105 5.63555 15.2734 5.3125 15.2734H2.38281V5.89844H5.3125C5.63555 5.89844 5.89844 6.16133 5.89844 6.48438V14.6875ZM15.8594 9.41406H17.0312C17.3543 9.41406 17.6172 9.67695 17.6172 10C17.6172 10.323 17.3543 10.5859 17.0312 10.5859H15.8594C15.5359 10.5859 15.2734 10.8484 15.2734 11.1719C15.2734 11.4953 15.5359 11.7578 15.8594 11.7578H17.0312C17.3543 11.7578 17.6172 12.0207 17.6172 12.3438C17.6172 12.6668 17.3543 12.9297 17.0312 12.9297H15.8594C15.5359 12.9297 15.2734 13.1922 15.2734 13.5156C15.2734 13.8391 15.5359 14.1016 15.8594 14.1016C16.1824 14.1016 16.4453 14.3645 16.4453 14.6875C16.4453 15.0105 16.1824 15.2734 15.8594 15.2734H10.9508C10.3828 15.2734 9.82148 15.1824 9.28281 15.0027L7.07031 14.2652V7.01484C7.98945 6.84023 8.88906 6.2582 9.70117 5.30547C10.4941 4.375 11.1371 3.14141 11.4211 2.00508L11.6293 1.17188H11.7578C12.4039 1.17188 12.9297 1.69766 12.9297 2.34375V2.9293C12.9297 3.71602 12.6836 5.225 12.3688 5.89844H11.1719C10.8484 5.89844 10.5859 6.16094 10.5859 6.48438C10.5859 6.80781 10.8484 7.07031 11.1719 7.07031H17.0312C17.3543 7.07031 17.6172 7.3332 17.6172 7.65625C17.6172 7.9793 17.3543 8.24219 17.0312 8.24219H15.8594C15.5359 8.24219 15.2734 8.50469 15.2734 8.82812C15.2734 9.15156 15.5359 9.41406 15.8594 9.41406Z"
                                            fill="#23C4A0"
                                        />
                                        <path
                                            d="M4.14062 17.6562C4.46423 17.6562 4.72656 17.3939 4.72656 17.0703C4.72656 16.7467 4.46423 16.4844 4.14062 16.4844C3.81702 16.4844 3.55469 16.7467 3.55469 17.0703C3.55469 17.3939 3.81702 17.6562 4.14062 17.6562Z"
                                            fill="#23C4A0"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        width="21"
                                        height="20"
                                        viewBox="0 0 21 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M19.2891 9.41406C19.2891 8.76953 18.7617 8.24219 18.1172 8.24219C18.7617 8.24219 19.2891 7.71484 19.2891 7.07031C19.2891 6.42578 18.7617 5.89844 18.1172 5.89844H13.3125C14.0273 3.75387 14.0156 3.07031 14.0156 1.75781C14.0156 0.782773 13.2162 0 12.2578 0H11.9062C11.6836 0 11.4023 0.17582 11.3437 0.445313C10.764 2.70238 9.85762 5.29234 7.57031 5.81695V14.2959L9.59762 14.9687C10.1953 15.1679 10.8164 15.2734 11.4492 15.2734H16.9453C17.5925 15.2734 18.1172 14.7487 18.1172 14.1016C18.1172 13.4543 17.5925 12.9297 16.9453 12.9297H18.1172C18.7617 12.9297 19.2891 12.4023 19.2891 11.7578C19.2891 11.1133 18.7617 10.5859 18.1172 10.5859C18.7617 10.5859 19.2891 10.0586 19.2891 9.41406Z"
                                            fill="#23C4A0"
                                        />
                                        <path
                                            d="M4.64062 4.72656H2.29688C1.97301 4.72656 1.71094 4.98863 1.71094 5.3125V15.8594C1.71094 16.1832 1.97301 16.4453 2.29688 16.4453H4.64062C5.60992 16.4453 6.39844 15.6568 6.39844 14.6875V6.48438C6.39844 5.51508 5.60992 4.72656 4.64062 4.72656ZM4.64062 14.1016C4.31703 14.1016 4.05469 13.8392 4.05469 13.5156C4.05469 13.192 4.31703 12.9297 4.64062 12.9297C4.96422 12.9297 5.22656 13.192 5.22656 13.5156C5.22656 13.8392 4.96422 14.1016 4.64062 14.1016Z"
                                            fill="#23C4A0"
                                        />
                                    </svg>
                                )}
                            </div>
                            {likeCount}
                        </div>
                        <div className={classes.CardLinkDislikesNum}>
                            <div className={classes.likesContainer}>
                                {likeStatus !== "dislike" ? (
                                    <svg
                                        onClick={
                                            place == "улицы"
                                                ? handleDislikeStreet
                                                : handleDislikeAddress
                                        }
                                        width="21"
                                        height="20"
                                        viewBox="0 0 21 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.15977 9.61719C1.88086 9.92851 1.71094 10.3395 1.71094 10.7891C1.71094 11.7582 2.49961 12.5469 3.46875 12.5469L6.88047 12.5469C6.54258 13.5723 6.39844 14.9328 6.39844 15.516L6.39844 16.1016C6.39844 17.3937 7.45 18.4453 8.74219 18.4453L9.32812 18.4453C9.59688 18.4453 9.83125 18.2625 9.89648 18.0016L10.2156 16.7246C10.6629 14.9363 12.0828 12.9633 13.5523 12.6047C13.8098 13.2562 14.4453 13.7187 15.1875 13.7187L18.7031 13.7187C19.0266 13.7187 19.2891 13.4563 19.2891 13.1328L19.2891 2.58594C19.2891 2.2625 19.0266 2 18.7031 2L15.1875 2C14.4887 2 13.884 2.40976 13.6008 3.00195L11.5875 2.33086C10.9293 2.11133 10.2434 2 9.54922 2L4.64063 2C3.67149 2 2.88281 2.78867 2.88281 3.75781C2.88281 3.98633 2.92656 4.20508 3.00625 4.40547C2.26094 4.60898 1.71094 5.29219 1.71094 6.10156C1.71094 6.55117 1.88086 6.96211 2.15977 7.27344C1.88086 7.58476 1.71094 7.9957 1.71094 8.44531C1.71094 8.89492 1.88086 9.30586 2.15977 9.61719ZM14.6016 3.75781C14.6016 3.43477 14.8645 3.17187 15.1875 3.17187L18.1172 3.17187L18.1172 12.5469L15.1875 12.5469C14.8645 12.5469 14.6016 12.284 14.6016 11.9609L14.6016 3.75781ZM4.64063 9.03125L3.46875 9.03125C3.1457 9.03125 2.88281 8.76836 2.88281 8.44531C2.88281 8.12226 3.1457 7.85937 3.46875 7.85937L4.64063 7.85937C4.96406 7.85937 5.22656 7.59687 5.22656 7.27344C5.22656 6.95 4.96406 6.6875 4.64063 6.6875L3.46875 6.6875C3.1457 6.6875 2.88281 6.42461 2.88281 6.10156C2.88281 5.77851 3.1457 5.51562 3.46875 5.51562L4.64063 5.51562C4.96406 5.51562 5.22656 5.25312 5.22656 4.92969C5.22656 4.60625 4.96406 4.34375 4.64063 4.34375C4.31758 4.34375 4.05469 4.08086 4.05469 3.75781C4.05469 3.43476 4.31758 3.17187 4.64063 3.17187L9.54922 3.17187C10.1172 3.17187 10.6785 3.26289 11.2172 3.44258L13.4297 4.18008L13.4297 11.4305C12.5105 11.6051 11.6109 12.1871 10.7988 13.1398C10.0059 14.0703 9.36289 15.3039 9.07891 16.4402L8.8707 17.2734L8.74219 17.2734C8.09609 17.2734 7.57031 16.7477 7.57031 16.1016L7.57031 15.516C7.57031 14.7293 7.81641 13.2203 8.13125 12.5469L9.32813 12.5469C9.65156 12.5469 9.91406 12.2844 9.91406 11.9609C9.91406 11.6375 9.65156 11.375 9.32813 11.375L3.46875 11.375C3.1457 11.375 2.88281 11.1121 2.88281 10.7891C2.88281 10.466 3.1457 10.2031 3.46875 10.2031L4.64063 10.2031C4.96406 10.2031 5.22656 9.94062 5.22656 9.61719C5.22656 9.29375 4.96406 9.03125 4.64063 9.03125Z"
                                            fill="#FF7485"
                                        />
                                        <path
                                            d="M16.3594 2.34375C16.0358 2.34375 15.7734 2.60608 15.7734 2.92969C15.7734 3.25329 16.0358 3.51562 16.3594 3.51562C16.683 3.51562 16.9453 3.25329 16.9453 2.92969C16.9453 2.60608 16.683 2.34375 16.3594 2.34375Z"
                                            fill="#FF7485"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className={classes.dislike}
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g clipPath="url(#clip0_788_850)">
                                            <path
                                                d="M1.21094 10.5859C1.21094 11.2305 1.73828 11.7578 2.38281 11.7578C1.73828 11.7578 1.21094 12.2852 1.21094 12.9297C1.21094 13.5742 1.73828 14.1016 2.38281 14.1016L7.18746 14.1016C6.47266 16.2461 6.48438 16.9297 6.48438 18.2422C6.48438 19.2172 7.28383 20 8.24219 20L8.59375 20C8.81641 20 9.09766 19.8242 9.15629 19.5547C9.73602 17.2976 10.6424 14.7077 12.9297 14.183L12.9297 5.70406L10.9024 5.03129C10.3047 4.83211 9.6836 4.7266 9.05078 4.7266L3.55469 4.7266C2.90746 4.72656 2.38281 5.25129 2.38281 5.89844C2.38281 6.54566 2.90746 7.07031 3.55469 7.07031L2.38281 7.07031C1.73828 7.07031 1.21094 7.59766 1.21094 8.24219C1.21094 8.88672 1.73828 9.41406 2.38281 9.41406C1.73828 9.41406 1.21094 9.94141 1.21094 10.5859Z"
                                                fill="#FF7485"
                                            />
                                            <path
                                                d="M15.8594 15.2734L18.2031 15.2734C18.527 15.2734 18.7891 15.0114 18.7891 14.6875L18.7891 4.14062C18.7891 3.81676 18.527 3.55469 18.2031 3.55469L15.8594 3.55469C14.8901 3.55469 14.1016 4.3432 14.1016 5.3125L14.1016 13.5156C14.1016 14.4849 14.8901 15.2734 15.8594 15.2734ZM15.8594 5.89844C16.183 5.89844 16.4453 6.16078 16.4453 6.48437C16.4453 6.80805 16.183 7.07031 15.8594 7.07031C15.5358 7.07031 15.2734 6.80805 15.2734 6.48437C15.2734 6.16078 15.5358 5.89844 15.8594 5.89844Z"
                                                fill="#FF7485"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_788_850">
                                                <rect
                                                    width="20"
                                                    height="20"
                                                    fill="white"
                                                    transform="translate(20 20) rotate(-180)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                )}
                            </div>
                            {dislikeCount}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withStyles(styles)(CardLink);
